//male sure only valid values are added here anything else will throw an error
//this is a good way to make sure that the values are not changed by mistake
const ProgramSubscriptions = Object.freeze({
  Rec: "Rec2.0",
  Metric: "Metric2.0",
  Default: "Default",
});

export { ProgramSubscriptions };
